import { MaritalStatus} from'../../Models/marital-status'

export const MARITALSTATUSES: MaritalStatus[] = [

]
